import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-terracotta-100 last:border-b-0" data-id="element-86">
      <button onClick={onToggle} className="w-full py-6 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2 rounded-lg" aria-expanded={isOpen} data-id="element-87">
        <span className="font-heading text-lg sm:text-xl text-charcoal pr-4" data-id="element-88">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-89">
          <ChevronDownIcon className="w-5 h-5 text-terracotta" data-id="element-90" />
        </motion.div>
      </button>

      <AnimatePresence initial={false} data-id="element-91">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-92">
            <p className="font-body text-warmGray pb-6 leading-relaxed" data-id="element-93">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Tengo que dejarlo llorar?',
    answer: 'No. El método se basa en responder siempre al llanto mientras se enseña autonomía.'
  }, {
    question: '¿Cuánto tiempo tardaré en ver resultados?',
    answer: 'La mayoría de las madres reportan cambios significativos en la tercera noche.'
  }, {
    question: '¿Funciona si hago lactancia materna?',
    answer: 'Sí, el manual incluye una sección específica para desvincular la succión del sueño sin afectar la lactancia.'
  }, {
    question: '¿Necesito comprar accesorios caros?',
    answer: 'No, usamos lo que ya tienes en casa de forma más inteligente.'
  }];
  return <section className="w-full bg-cream py-20 px-4" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-96">
          <div className="flex justify-center mb-4" data-id="element-97">
            <div className="w-12 h-12 bg-terracotta-100 rounded-full flex items-center justify-center" data-id="element-98">
              <HelpCircleIcon className="w-6 h-6 text-terracotta" data-id="element-99" />
            </div>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl text-charcoal" data-id="element-100">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <motion.div className="bg-warmWhite rounded-3xl p-6 sm:p-8 shadow-warm border border-terracotta-100" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-101">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-102" />)}
        </motion.div>
      </div>
    </section>;
}